var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStoreBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 62,
    viewBox: "0 0 173 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.410147,
    y: 0.777335,
    width: 172.18,
    height: 59.8815,
    rx: 29.9407,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.820294
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.6987 23.0021C88.7154 23.0021 87.8865 22.6566 87.231 21.9766C86.5809 21.3157 86.2179 20.4045 86.2342 19.4743C86.2342 18.4815 86.5701 17.641 87.231 16.9746C87.8838 16.2947 88.7127 15.9492 89.696 15.9492C90.6684 15.9492 91.4973 16.2947 92.1637 16.9746C92.8246 17.6628 93.1605 18.5033 93.1605 19.4743C93.1497 20.4698 92.8138 21.3103 92.1637 21.9739C91.5109 22.6594 90.682 23.0021 89.6987 23.0021ZM60.4412 23.0021C59.4795 23.0021 58.6452 22.6621 57.9626 21.9902C57.2854 21.3211 56.9414 20.4752 56.9414 19.477C56.9414 18.4788 57.2854 17.6329 57.9626 16.9638C58.6317 16.2919 59.466 15.9519 60.4412 15.9519C60.9179 15.9519 61.3811 16.0471 61.8253 16.2403C62.2615 16.4279 62.6163 16.6836 62.8791 16.9964L62.9441 17.0753L62.21 17.7988L62.1341 17.709C61.7197 17.214 61.1644 16.9719 60.4303 16.9719C59.7748 16.9719 59.2032 17.2058 58.7319 17.6682C58.2579 18.1333 58.0168 18.7426 58.0168 19.4797C58.0168 20.2168 58.2579 20.8261 58.7319 21.2912C59.2032 21.7536 59.7748 21.9875 60.4303 21.9875C61.1292 21.9875 61.717 21.7536 62.1748 21.2912C62.4456 21.0192 62.6136 20.6384 62.6732 20.157H60.3193V19.1397H63.6836L63.6971 19.2322C63.7215 19.4036 63.7459 19.5804 63.7459 19.7436C63.7459 20.6819 63.4642 21.4408 62.9061 22.0011C62.2723 22.6648 61.4434 23.0021 60.4412 23.0021ZM99.342 22.8579H98.3045L95.1271 17.7526L95.1542 18.6719V22.8552H94.1167V16.0961H95.3005L95.333 16.1478L98.3208 20.9567L98.2937 20.04V16.0961H99.342V22.8579ZM81.9028 22.8579H80.8518V17.1134H79.0288V16.0961H83.7231V17.1134H81.9001V22.8579H81.9028ZM78.1728 22.8579H77.1245V16.0961H78.1728V22.8579ZM72.2812 22.8579H71.2329V17.1134H69.4099V16.0961H74.1042V17.1134H72.2812V22.8579ZM68.7463 22.847H64.7264V16.0961H68.7463V17.1134H65.7775V18.9684H68.4564V19.9748H65.7775V21.8298H68.7463V22.847ZM88.0003 21.2776C88.4689 21.7482 89.0378 21.9848 89.6987 21.9848C90.3786 21.9848 90.9339 21.7536 91.3971 21.2776C91.8576 20.8152 92.0906 20.2087 92.0906 19.477C92.0906 18.7453 91.8576 18.1361 91.3998 17.6764C90.9312 17.2058 90.3596 16.9692 89.7014 16.9692C89.0215 16.9692 88.4662 17.2004 88.0057 17.6764C87.5452 18.1388 87.3123 18.7453 87.3123 19.477C87.3123 20.2087 87.5425 20.8179 88.0003 21.2776Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1357 32.3C83.5759 32.3 81.501 34.2502 81.501 36.9403C81.501 39.6058 83.5894 41.5805 86.1357 41.5805C88.6955 41.5805 90.7705 39.6167 90.7705 36.9403C90.7705 34.2502 88.6955 32.3 86.1357 32.3ZM86.1357 39.7418C84.7353 39.7418 83.5298 38.5777 83.5298 36.9294C83.5298 35.2566 84.738 34.117 86.1357 34.117C87.5362 34.117 88.7416 35.2566 88.7416 36.9294C88.7443 38.5886 87.5362 39.7418 86.1357 39.7418ZM76.0238 32.3C73.4639 32.3 71.389 34.2502 71.389 36.9403C71.389 39.6058 73.4775 41.5805 76.0238 41.5805C78.5836 41.5805 80.6585 39.6167 80.6585 36.9403C80.6585 34.2502 78.5809 32.3 76.0238 32.3ZM76.0238 39.7418C74.6233 39.7418 73.4179 38.5777 73.4179 36.9294C73.4179 35.2566 74.626 34.117 76.0238 34.117C77.4242 34.117 78.6296 35.2566 78.6296 36.9294C78.6296 38.5886 77.4242 39.7418 76.0238 39.7418ZM63.9913 33.7171V35.6809H68.6856C68.542 36.7825 68.1791 37.5958 67.6238 38.1534C66.9357 38.8442 65.8739 39.595 64.0021 39.595C61.1172 39.595 58.8608 37.2558 58.8608 34.359C58.8608 31.4623 61.1172 29.1231 64.0021 29.1231C65.5597 29.1231 66.6946 29.7406 67.5371 30.5293L68.924 29.1367C67.7538 28.0107 66.1962 27.1484 64.0129 27.1484C60.0554 27.1484 56.7344 30.3852 56.7344 34.3482C56.7344 38.322 60.0527 41.5479 64.0129 41.5479C66.1502 41.5479 67.7538 40.8461 69.0215 39.5242C70.3136 38.2268 70.7226 36.3963 70.7226 34.9194C70.7226 34.4597 70.6874 34.0462 70.6143 33.6954H63.9885C63.9913 33.6927 63.9913 33.7171 63.9913 33.7171ZM113.207 35.2457C112.82 34.204 111.65 32.2892 109.25 32.2892C106.872 32.2892 104.894 34.1686 104.894 36.9294C104.894 39.5351 106.85 41.5696 109.48 41.5696C111.593 41.5696 112.823 40.2722 113.329 39.5106L111.761 38.4553C111.241 39.2305 110.518 39.7391 109.491 39.7391C108.454 39.7391 107.728 39.2658 107.245 38.3329L113.424 35.7625C113.424 35.7653 113.207 35.2457 113.207 35.2457ZM106.907 36.7961C106.858 35.0037 108.294 34.0925 109.32 34.0925C110.13 34.0925 110.805 34.4923 111.035 35.0744L106.907 36.7961ZM101.887 41.2922H103.916V27.6598H101.887V41.2922ZM98.5556 33.3309H98.4824C98.0246 32.7842 97.1551 32.2892 96.0445 32.2892C93.7393 32.2892 91.6156 34.3264 91.6156 36.943C91.6156 39.5487 93.7285 41.5615 96.0445 41.5615C97.1416 41.5615 98.0246 41.0637 98.4824 40.5061H98.5556V41.1725C98.5556 42.9432 97.6129 43.8979 96.0933 43.8979C94.8499 43.8979 94.0779 43.0003 93.7637 42.2496L92.0003 42.9895C92.5068 44.2134 93.8585 45.7285 96.0906 45.7285C98.4689 45.7285 100.484 44.3222 100.484 40.8924V32.5666H98.5664V33.3309C98.5691 33.3309 98.5556 33.3309 98.5556 33.3309ZM96.226 39.7418C94.8256 39.7418 93.6553 38.5668 93.6553 36.943C93.6553 35.3056 94.8256 34.1197 96.226 34.1197C97.6129 34.1197 98.6883 35.3192 98.6883 36.943C98.7018 38.5668 97.6156 39.7418 96.226 39.7418ZM122.707 27.6598H117.856V41.2922H119.885V36.1297H122.71C124.956 36.1297 127.163 34.495 127.163 31.9002C127.163 29.3054 124.964 27.6598 122.707 27.6598ZM122.767 34.2258H119.882V29.5474H122.767C124.286 29.5474 125.145 30.8068 125.145 31.8866C125.145 32.9555 124.276 34.2258 122.767 34.2258ZM135.295 32.2756C133.821 32.2756 132.302 32.9311 131.673 34.359L133.472 35.1097C133.859 34.359 134.569 34.1034 135.319 34.1034C136.37 34.1034 137.432 34.7344 137.457 35.8605V36.0046C137.094 35.7979 136.297 35.4824 135.344 35.4824C133.402 35.4824 131.432 36.5486 131.432 38.5478C131.432 40.3783 133.025 41.5533 134.799 41.5533C136.162 41.5533 136.912 40.9359 137.381 40.2205H137.454V41.2759H139.41V36.0536C139.41 33.6219 137.611 32.2756 135.295 32.2756ZM135.04 39.7418C134.377 39.7418 133.448 39.4154 133.448 38.5777C133.448 37.5223 134.607 37.1225 135.596 37.1225C136.49 37.1225 136.912 37.3156 137.443 37.5822C137.297 38.8062 136.268 39.731 135.04 39.7418ZM146.545 32.5666L144.215 38.4798H144.142L141.728 32.5666H139.545L143.167 40.8325L141.103 45.4265H143.216L148.788 32.5666H146.545ZM128.282 41.2922H130.311V27.6598H128.282V41.2922Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4645 16.7883C23.1502 17.1283 22.9688 17.6478 22.9688 18.3278V42.4456C22.9688 43.1256 23.1502 43.6451 23.4753 43.9715L23.5593 44.045L37.0166 30.5322V30.2303L23.5484 16.7148L23.4645 16.7883Z",
    fill: "url(#paint0_linear_2534_25999)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4963 35.0521L37.0078 30.5451V30.2296L41.4963 25.7227L41.5938 25.7825L46.9031 28.8125C48.4228 29.672 48.4228 31.0919 46.9031 31.9622L41.5938 34.9923L41.4963 35.0521Z",
    fill: "url(#paint1_linear_2534_25999)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5921 34.9916L37.0061 30.3867L23.4648 43.9838C23.9606 44.5169 24.7922 44.5767 25.7213 44.0572L41.5921 34.9916Z",
    fill: "url(#paint2_linear_2534_25999)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5921 25.7803L25.7213 16.7283C24.7922 16.1952 23.9578 16.2686 23.4648 16.8017L37.0061 30.3852L41.5921 25.7803Z",
    fill: "url(#paint3_linear_2534_25999)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4917 34.8945L25.7291 43.8867C24.8487 44.3953 24.0632 44.3599 23.5566 43.8976L23.4727 43.9819L23.5566 44.0553C24.0632 44.515 24.8487 44.5531 25.7291 44.0444L41.6 34.9924L41.4917 34.8945Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9008 31.8038L41.4805 34.8937L41.578 34.9916L46.8872 31.9616C47.6484 31.5264 48.0222 30.9552 48.0222 30.3867C47.9762 30.909 47.5888 31.404 46.9008 31.8038Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7209 16.8869L46.901 28.9689C47.589 29.3579 47.9764 29.8665 48.036 30.386C48.036 29.8176 47.6622 29.2464 46.901 28.8112L25.7209 16.7291C24.2013 15.856 22.9688 16.585 22.9688 18.3285V18.4862C22.9688 16.74 24.2013 16.0247 25.7209 16.8869Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2534_25999",
    x1: 35.8095,
    y1: 18.0676,
    x2: 14.2415,
    y2: 23.7908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2534_25999",
    x1: 48.8849,
    y1: 30.3874,
    x2: 22.6014,
    y2: 30.3874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2534_25999",
    x1: 39.0984,
    y1: 32.8924,
    x2: 21.6878,
    y2: 62.0758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2534_25999",
    x1: 20.055,
    y1: 8.76615,
    x2: 27.8226,
    y2: 21.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreBorder);
export default __webpack_public_path__ + "static/media/play_store_border.d035c8000cdf057114ab415de192a673.svg";
export { ForwardRef as ReactComponent };